import { render, staticRenderFns } from "./IframeTemp.vue?vue&type=template&id=101b0174&"
import script from "./IframeTemp.vue?vue&type=script&lang=js&"
export * from "./IframeTemp.vue?vue&type=script&lang=js&"
import style0 from "./IframeTemp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('101b0174')) {
      api.createRecord('101b0174', component.options)
    } else {
      api.reload('101b0174', component.options)
    }
    module.hot.accept("./IframeTemp.vue?vue&type=template&id=101b0174&", function () {
      api.rerender('101b0174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/iframe/IframeTemp.vue"
export default component.exports